// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanDeleteOrganization } from "./hook";

export type CanDeleteOrganizationProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanDeleteOrganization({
  children,
  fallback,
  scope,
}: CanDeleteOrganizationProps) {
  const canDoAction = useCanDeleteOrganization(scope);
  return <>{canDoAction ? children : fallback}</>;
}
